// extracted by mini-css-extract-plugin
export default {"icon":"styles_icon__yb1N4","container":"styles_container__VeOFJ","actions":"styles_actions__PAcuJ","label":"styles_label__AGsbi"};